import { Typography } from '@/components/Atoms';
import React, { useState } from 'react';

export interface CustomToggleProps {
  options: string[];
  onToggle: (selected: string) => void;
}

const CustomToggle: React.FunctionComponent<CustomToggleProps> = ({ options, onToggle }) => {
  const [selected, setSelected] = useState(options[0]);

  const handleToggle = (option: string) => {
    setSelected(option);
    onToggle(option);
  };

  return (
    <div className='toggle-container'>
      {options.map((option) => (
        <button
          key={option}
          className={`toggle-button flex justify-center items-center ${selected === option ? 'selected' : ''}`}
          onClick={() => handleToggle(option)}
        >
          <Typography Component={'p'} size='s12ToS12' isBold>
            {option}
          </Typography>
        </button>
      ))}
      <style jsx>{`
        .toggle-container {
          display: flex;
          background-color: #0e463c;
          border-radius: 20px;
          padding: 4px;
          width: max-content;
        }
        .toggle-button {
          flex: 1;
          background: none;
          border: none;
          color: white;
          padding: 8px 12px;
          border-radius: 20px;
          cursor: pointer;
        }
        .toggle-button.selected {
          background-color: white; /* Highlight for selected option */
          color: #0e4050;
        }
        .toggle-button:not(.selected):hover {
          opacity: 0.8;
        }
      `}</style>
    </div>
  );
};

export default CustomToggle;
